export default __webpack_public_path__ + "static/media/rolo.0d9996d4.png";